var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material-auto-cut"},[_vm._l((_vm.data),function(item){return [_c('div',{key:item.key,ref:`domRef${item.key}`,refInFor:true,style:(_vm.imgBoxStyle(item))},[_c('img',{style:(_vm.imgStyle(item)),attrs:{"src":item.url}})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }